import Select from 'react-select';

export default function TableSegmentSearch({ mergedData, setMergedData, searchKeyword, setSearchKeyword, selectClassName, ...props }) {
  const { isDisabled } = props;

  const onChange = (option) => {
    if (!option) {
      setSearchKeyword('');
      return;
    }
    const newSearchKeyword = option.map((segment) => segment.value).join('/');
    setSearchKeyword(newSearchKeyword);
  };

  const pagesSeparatedBySlash = mergedData?.rows
    ?.map((page) => {
      const path = page.dimension_values[0];

      // Only get the paths that contain the search keyword
      if (searchKeyword && !path.includes(searchKeyword + '/')) {
        return null;
      }

      const segments = path.split('/');

      // If it's the root path '/', return an array with just that
      if (path === '/') {
        return ['/'];
      }

      // Filter out empty strings and handle other paths
      return segments.filter((segment) => segment.length > 0);
    })
    .filter(Boolean);

  const pathSegments = pagesSeparatedBySlash?.reduce((acc, path) => {
    path.forEach((segment, index) => {
      // Create array for this level if it doesn't exist
      acc[index] = acc[index] || [];
      // Add segment if it's not already in the array
      if (!acc[index].includes(segment)) {
        acc[index].push(segment);
      }
    });
    return acc;
  }, []);

  const slashes = searchKeyword ? (searchKeyword.split('/').length < 1 ? searchKeyword.split('/').length - 1 : 1) : 0;

  const options = pathSegments ? pathSegments[slashes]?.map((segment) => ({ value: segment, label: segment })) : [];

  // Make a variable called value that works with the Select component
  const value = searchKeyword
    ? searchKeyword === '/'
      ? [{ value: '/', label: '/' }]
      : searchKeyword.split('/').map((segment) => ({ value: segment, label: segment }))
    : [];

  return (
    <div>
      <Select
        {...props}
        isDisabled={isDisabled}
        isMulti
        className={`basic-multi-select ${selectClassName}`}
        placeholder="Search for a page by URL segment..."
        classNamePrefix="select"
        maxMenuHeight={400}
        isClearable
        options={options}
        value={value}
        onChange={(newValue, actionMeta) => {
          if (actionMeta.action === 'clear' || !newValue) {
            onChange(null);
            return;
          }

          onChange(newValue);
        }}
        classNames={{
          clearIndicator: (state) => (state.isFocused ? 'text-white opacity-50' : ''),
          dropdownIndicator: (state) => (state.isFocused ? 'text-white opacity-50' : ''),
        }}
        styles={{
          singleValue: (baseStyles, props) => ({
            ...baseStyles,
            color: 'white',
          }),
          clearIndicator: (baseStyles, props) => ({
            ...baseStyles,
            color: 'white',
          }),
          dropdownIndicator: (baseStyles, props) => ({
            ...baseStyles,
            color: 'white',
          }),
          container: (baseStyles, props) => ({
            ...baseStyles,
            background: '#382e5c',
            borderRadius: '0.375rem',
            borderColor: '#382e5c',
          }),
          control: (baseStyles, state) => ({
            ...baseStyles,
            background: '#382e5c',
            borderRadius: '0.375rem',
            borderColor: '#382e5c',
            width: '400px',
          }),
          input: (baseStyles, props) => ({
            ...baseStyles,
            color: 'white',
          }),
          menu: (baseStyles, props) => ({
            ...baseStyles,
            background: '#382e5c',
            color: 'white',
            borderRadius: '0.375rem',
            borderColor: 'black',
            padding: '1rem',
            zIndex: 99,
          }),
          menuList: (baseStyles, props) => ({
            background: '#382e5c',
            color: 'white',
            overflow: 'scroll',
            maxHeight: '220px',
          }),
          placeholder: (baseStyles, props) => ({
            ...baseStyles,
            color: '#6E84A3',
          }),
          noOptionsMessage: (baseStyles, props) => ({
            ...baseStyles,
            color: '#6E84A3',
          }),
          option: (baseStyles, props) => ({
            ...baseStyles,
            background: '#382e5c',
            '&:hover': {
              backgroundColor: '#3489ec',
            },
          }),
          multiValue: (baseStyles, props) => ({
            ...baseStyles,
            background: '#54c7d7',
            borderColor: '#54c7d7',
          }),
          multiValueLabel: (baseStyles, props) => ({
            ...baseStyles,
            color: 'white',
          }),
          multiValueRemove: (baseStyles, props) => ({
            ...baseStyles,
            '&:hover': {
              backgroundColor: 'transparent',
              color: '#DE350B',
            },
          }),
        }}
      />
    </div>
  );
}
